export default __webpack_public_path__ + "static/media/kimiya-logo-blue.90d73293.svg";